export const footer_links: Record<string, string> = {
  footer_top_title: 'footer-top-title',
};
